import { render, staticRenderFns } from "./KeychainsForm.vue?vue&type=template&id=205ee9dc"
import script from "./KeychainsForm.vue?vue&type=script&lang=js"
export * from "./KeychainsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports